import { useState, useEffect, RefObject, useRef } from "react";

const useDynamicHeight = (offset: number) => {
  const [height, setHeight] = useState(0);
  const headerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleResize = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      setHeight(window.innerHeight - (offset + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [offset, headerRef]);

  return height;
};

export default useDynamicHeight;

// const headerRef = useRef<HTMLDivElement>(null);
// const height = useDynamicHeight(200, headerRef);
